/**
 * Hook for the auditors list toolbar: name search with autocomplete suggestions.
 * Filtering updates the table rows through the page's `setRows` delegate.
 */
import React from 'react';

export function useAuditorSearch(auditors, setRows) {
    const [suggestions, setSuggestions] = React.useState([]);
    const [searchValue, setSearchValue] = React.useState('');

    const onSearch = (search) => {
        setSearchValue(search);
        if (!search || typeof search !== 'string') {
            setSuggestions([]);
            setRows(auditors);
            return;
        }
        const filteredData = auditors.filter((c) => c.name && c.name.toLowerCase().includes(search.toLowerCase()));
        setRows(filteredData);
        setSuggestions(filteredData?.map((c) => c.name) ?? []);
    };

    return { suggestions, searchValue, setSearchValue, onSearch };
}
